import { CLEAR_REQUIRED_DOCUMENT_DATA,GET_REQUIRED_DOCUMENT_DATA } from "../../constants/userDocument/UserDocument"


const initialState = {
    RequiredDocumentListData: null
}
export const GetRequiredDocumentDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REQUIRED_DOCUMENT_DATA:
            return {
                ...state,
                RequiredDocumentListData: action.payload.requiredDocuments,
            }
        case CLEAR_REQUIRED_DOCUMENT_DATA:
            return {
               ...state,
               RequiredDocumentListData: null,
            }
        default:
            return state
    }
}  